import rawUpdates from './updates.json';

export type UpdateVisual = 'confidence' | 'conversation' | 'workspace' | 'editor' | 'export' | 'scope' | 'publish' | 'foundation';

export interface UpdateSection {
  eyebrow: string;
  title: string;
  body: string[];
}

export interface ProductUpdate {
  slug: string;
  publishedAt: string;
  displayDate: string;
  category: string;
  title: string;
  summary: string;
  lede: string;
  visual: UpdateVisual;
  availability: string;
  featured: boolean;
  highlights: string[];
  sections: UpdateSection[];
}

export const productUpdates = rawUpdates as ProductUpdate[];

/** New releases are added first, so every published update automatically gets
 * one in-product announcement without a second flag that can drift. */
export const latestInAppUpdate = productUpdates[0];

export function findProductUpdate(slug: string | undefined): ProductUpdate | undefined {
  return productUpdates.find((update) => update.slug === slug);
}
